export const StepperStatusEnum = {
  DONE: 'done',
  IN_PROGRESS: 'in-progress',
  FUTURE: 'future',
};
